import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { formatDate } from '@angular/common';
import { UserConfigsService } from '../../../services/user-configs.service';
import { UserConfigs } from '../../../models/user-configs.model';
import { SelectedRangeEvent } from '../bates-range-select/bates-range-select.component';
import { FieldLayoutViewModelService } from 'src/app/services/field-layout-view-model.service';
import { ProductionJobSdk } from 'src/app/sdks/production-job.sdk';
import { ProductionJobView } from '@models/ui/production-job-view.model';

@Component({
    selector: 'lex-create-production-job',
    templateUrl: './create-production-job.component.html',
    styleUrls: ['./create-production-job.component.scss'],
    standalone: false
})
export class CreateProductionJobComponent implements OnInit {

  @Input() productionJobs: ProductionJobView[];
  @Output() createProductionEvent: EventEmitter<ProductionJobView> = new EventEmitter<ProductionJobView>();

  private batesRangeGroups: Map<string, ProductionJobView[]> = new Map<string, ProductionJobView[]>();
  private userConfig: UserConfigs;

  constructor(private userConfigService: UserConfigsService,
    private fieldLayoutViewModelService: FieldLayoutViewModelService,
    private productionJobSdk: ProductionJobSdk) { }

  ngOnInit(): void {
    this.userConfigService.getUserConfigs().subscribe((config: UserConfigs) => { this.userConfig = config });
  }

  public startNewPrefix(): void {
    const job = new ProductionJobView();
    job.title = `Production ${formatDate(new Date(), 'MM-dd-yyyy', 'en-US')}`;
    job.batesBasePrefix = '';
    job.batesBaseNumberStart = 1;
    job.batesBaseNumberDigits = 7;
    job.isBatesStampPages = true;
    job.isCreateTiff = false;
    job.isIncludeNativeEmails = false;
    this.selectedRangeEvent({
      productionJob: job,
      lastRunProductionJob: null
    });
  }

  public selectedRangeEvent(event: SelectedRangeEvent): void {
    event.productionJob.createdById = this.userConfig.userId;
    event.productionJob.caseId = this.userConfig.currentCase.caseId;
    this.productionJobSdk.createProduction(event.productionJob).subscribe((data: ProductionJobView) => {
      if (!event.lastRunProductionJob) {
        this.createProductionEvent.emit(data);
      } else {
        this.productionJobSdk
          .getLoadfileFieldLayout(event.lastRunProductionJob.productionJobId)
          .subscribe((lastFieldLayout) => {
            this.productionJobSdk
              .getLoadfileFieldLayout(data.productionJobId)
              .subscribe((fieldLayout) => {
                lastFieldLayout.fieldLayoutId = fieldLayout.fieldLayoutId
                lastFieldLayout.fields.forEach(field => {
                  field.fieldLayoutId = fieldLayout.fieldLayoutId
                })
                this.fieldLayoutViewModelService.updateFieldLayout(lastFieldLayout).subscribe(() => {
                  this.createProductionEvent.emit(data);
                })
              });
          })
      }

    });
  }
}
